import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../console/store/useAuthStore";
import { enum_api_uri } from "../utils/enum";

export interface SenderData {
    sender_idx: number;
    default_sender: string;
    union_option: boolean;
    union_sender: string;
}

interface GetSenderResponse {
    data: SenderData[];
}

export const useGetCommonSender = (
    customerIdx?: string,
    searchtxt?: string,
    newOptions?: {},
    productIdx?: number,
): UseQueryResult<GetSenderResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetSenderResponse, Error>({
        queryKey: ["getCommonSender", customerIdx, searchtxt, productIdx],
        queryFn: async () => {
            if (!customerIdx) throw new Error("Invalid request data");

            const response = await axios.get(`${enum_api_uri.common_get_sender}/${customerIdx}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    search: "sender",
                    searchtxt,
                    product_category_idx: productIdx,
                },
            });
            return response.data;
        },
        ...newOptions,
    });
};
